module.exports = __webpack_public_path__ + "static/media/16.2f3aa3d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/16.png
// module id = 653
// module chunks = 0